import React from 'react';
import classNames from 'classnames';

import css from './IconCarouselArrows.module.css';

/**
 * Carousel arrows
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconCarouselArrows = props => {
  const { rootClassName, className, type } = props;
  const classes = classNames(rootClassName || css.root, className);


  if (type === "white-left") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="none"
        viewBox="0 0 32 32"
      >
        <rect width="32" height="32" fill="#F8F8F8" rx="12"></rect>
        <path
          fill="#19191A"
          fillRule="evenodd"
          d="M18.429 10.407a.5.5 0 0 1 .705.709l-5.207 5.165 5.207 5.166a.5.5 0 0 1-.705.71l-5.564-5.522-.357-.354.357-.355z"
          clipRule="evenodd"
        ></path>
      </svg>
    )
  } else if (type === "white-right") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="none"
        viewBox="0 0 32 32"
      >
        <rect width="32" height="32" fill="#F8F8F8" rx="12"></rect>
        <path
          fill="#19191A"
          fillRule="evenodd"
          d="M12.864 10.41a.5.5 0 0 1 .707-.004l5.564 5.522.357.354-.357.355-5.564 5.52a.5.5 0 0 1-.705-.71l5.207-5.165-5.207-5.166a.5.5 0 0 1-.002-.707"
          clipRule="evenodd"
        ></path>
      </svg>
    )
  } else if (type === "black-left") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="none"
        viewBox="0 0 32 32"
      >
        <rect
          width="31"
          height="31"
          x="0.5"
          y="0.5"
          stroke="#19191A"
          rx="11.5"
        ></rect>
        <path
          fill="#19191A"
          fillRule="evenodd"
          d="M18.429 10.407a.5.5 0 0 1 .705.709l-5.207 5.165 5.207 5.166a.5.5 0 0 1-.705.71l-5.564-5.522-.357-.354.357-.355z"
          clipRule="evenodd"
        ></path>
      </svg>
    )
  } else if (type === "black-right") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="none"
        viewBox="0 0 32 32"
      >
        <rect
          width="31"
          height="31"
          x="0.5"
          y="0.5"
          stroke="#19191A"
          rx="11.5"
        ></rect>
        <path
          fill="#19191A"
          d="M12.864 10.41a.5.5 0 0 1 .707-.004l5.564 5.522.357.354-.357.355-5.564 5.52a.5.5 0 0 1-.705-.71l5.207-5.165-5.207-5.166a.5.5 0 0 1-.002-.707"
        ></path>
      </svg>
    )
  } else if (type === "transparent-left") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="none"
        viewBox="0 0 32 32"
      >
        <rect
          width="31"
          height="31"
          x="0.5"
          y="0.5"
          stroke="#F8F8F8"
          rx="11.5"
        ></rect>
        <path
          fill="#F8F8F8"
          d="M18.429 10.407a.5.5 0 0 1 .705.709l-5.207 5.165 5.207 5.166a.5.5 0 0 1-.705.71l-5.564-5.522-.357-.354.357-.355z"
        ></path>
      </svg>
    )
  } else if (type === "transparent-right") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="none"
        viewBox="0 0 32 32"
      >
        <rect
          width="31"
          height="31"
          x="0.5"
          y="0.5"
          stroke="#F8F8F8"
          rx="11.5"
        ></rect>
        <path
          fill="#F8F8F8"
          fillRule="evenodd"
          d="M12.864 10.41a.5.5 0 0 1 .707-.004l5.564 5.522.357.354-.357.355-5.564 5.52a.5.5 0 0 1-.705-.71l5.207-5.165-5.207-5.166a.5.5 0 0 1-.002-.707"
          clipRule="evenodd"
        ></path>
      </svg>
    )
  }
  else {
    return null
  }

};

export default IconCarouselArrows;
